/** 
 Copyright Highway9 Networks Inc. 
 */ 
import { AccessConfig, AccessConfigTemplate } from "~/types/accessConfig";
import APIService from "./APIServices";

const AccessConfigAPI = new APIService<AccessConfig>("accessConfig");

export const accessConfigService = {
  getAccessConfigData: AccessConfigAPI.getAll,
  createRif: AccessConfigAPI.create,
  updateRif: AccessConfigAPI.update,
  deleteRif: AccessConfigAPI.delete,
  getAccessConfigTemplate : () => AccessConfigAPI.get<AccessConfigTemplate[]>('template'),
};
